import api from '../axiosConfig';

const API_URL = '/api/raw-stock'; 

export const fetchRawStocks = (params = {}) => api.get(API_URL, { params });
export const createRawStock = (data) => api.post(API_URL, data);
export const updateRawStock = (id, data) => api.put(`${API_URL}/${id}`, data);
export const deleteRawStock = (id) => api.delete(`${API_URL}/${id}`);
export const fetchRawStockReport = (filters = {}) =>
  api.get(`${API_URL}/report`, { params: filters }); 